import type { IconSvgObject } from './types';

const SortingAZ01Icon: IconSvgObject = [
  ["path", { d: "M15 9.5H18.5V10L15 14V14.5H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 14.5L4.99702 9H6L8 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 12H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 7.5V7C2 5.89543 2.89543 5 4 5H18.5L16.5 2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M22 16.5L21.999 16.9018C21.9963 17.9989 21.1103 18.889 20.0132 18.8968L5.5 19L8 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default SortingAZ01Icon;
